import { AUTH_ROUTE_NAME } from "@/libs/route-name";

export const activeEmailRoute = () => {
  return {
    name: AUTH_ROUTE_NAME.ACTIVE_EMAIL,
    path: "active-email",
    component: () => import("@/pages/auth/active-email.vue")
  };
};
